import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { useTranslation } from 'react-i18next';
import { getErrorMessage } from 'utilities/ErrorHelper';

export const useGetProfile = () => {
  const profileService = useServices().profileService;
  return useQuery({
    queryKey: ['profileData'],
    queryFn: async () => {
      const response = await profileService.getProfile();
      localStorage.culture = response.culture;
      return response;
    },
    refetchOnWindowFocus: false
  });
};

export const useGetSignUpLists = () => {
  const profileService = useServices().profileService;
  return useQuery({
    queryKey: ['signUpLists'],
    queryFn: profileService.getSignUpLists,
    refetchOnWindowFocus: false
  });
};

export const useSaveProfile = (saveProfilePayload) => {
  const { t } = useTranslation();
  const profileService = useServices().profileService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: () => profileService.saveProfile(saveProfilePayload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profileData'] });
      notificationsStore.addToast('success', t('YourProfileHasBeenSaved', { ns: 'editProfile' }), 'success');
    },
    onError: (error: Error) => {
      notificationsStore.addToast('error', getErrorMessage(error), 'error');
    },
  });
};
